export default "__VITE_ASSET__OahkJ4Oe__"